import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../services/api";

export const LATEST_QUERIES_KEY = ["latest queries"];

export const useGetLatestQueries = () => {
  const { data } = useQuery<AxiosResponse<Array<string>>>({
    queryKey: LATEST_QUERIES_KEY,
    queryFn: api.listSearchHistory
  });

  return { data };
};
